import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import TokenService from '../services/tokens';
import TokenLicenseService from '../services/token-license';
import LoadingState from '../utilities/loading_state'
import { generateClient } from 'aws-amplify/api';
import * as mutations from '../graphql/mutations';

const initialState = {
  items: [],
  loadingState: LoadingState.idle
};

export const createToken = createAsyncThunk(
  'TOKENS/CREATE',
  async (data, { rejectWithValue }) => {
    try {
      const res = await TokenService.create(data);
      return res;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue({ ...err, ...err.response.data });
    }
  }
);

export const getTokens = createAsyncThunk(
  'TOKENS/GETLIST',
  async (param, { rejectWithValue, getState }) => {
    try {
      const isAdmin = getState().currentUser.groups.includes('admin')
      if (!isAdmin) {
        param = {
          and: [
             param ,
            {
              deleted: {
                eq: false
              }
            }
          ]
        }
      }
      const res = await TokenService.getList(param);
      return res;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue({ ...err, ...err.response.data });
    }
  }
);

export const getToken = createAsyncThunk('TOKENS/GET', async (id, { rejectWithValue }) => {
  try {
    const res = await TokenService.get(id);
    return res.data;
  } catch (err) {
    if (!err.response) {
      throw err;
    }
    return rejectWithValue({ ...err, ...err.response.data });
  }
});

export const updateToken = createAsyncThunk(
  'TOKENS/UPDATE',
  async (data, { rejectWithValue }) => {
    try {
      if (!data.active) {
        let client = generateClient();
        client.graphql({
          query: mutations.deleteClient,
          variables: {
            input: {
              token: data.id,
              site: '',
              customer: ''
            }
          }
        })
          .then(data => {
          })
          .catch(err => console.log(err))
          ;
      }
      const res = await TokenService.update(data);
      return res;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue({ ...err, ...err.response.data });
    }
  }
);

export const deleteToken = createAsyncThunk(
  'TOKENS/DELETE',
  async (id, { rejectWithValue, getState }) => {
    try {
      const matching_licenses = await TokenLicenseService.getList({
        tokenLicenseTokenId: {
          eq: id
        }
      })
      if (matching_licenses.length > 0) {
        throw new Error("Cannot delete token with existing licenses")
      }
      const isAdmin = getState().currentUser.groups.includes('admin')
      if (isAdmin) {
        await TokenService.del(id);
      } else {
        await TokenService.update({
          id,
          deleted: true
        });
      }
      return { id };
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue({ ...err, ...err.response.data });
    }
  }
);

const tokenSlice = createSlice({
  name: 'TOKEN',
  initialState,
  extraReducers: {
    [createToken.fulfilled]: (state, action) => {
      state.items.push(action.payload);
    },
    [getTokens.pending]: (state, action) => {
      return {
        items: [],
        loading_state: LoadingState.loading
      };
    },
    [getTokens.fulfilled]: (state, action) => {
      return {
        items: [...action.payload],
        loading_state: LoadingState.ready
      };
    },
    [getToken.fulfilled]: (state, action) => {
      const index = state.items.findIndex((user) => user.id === action.payload.id);
      state.items[index] = {
        ...state[index],
        ...action.payload[0]
      };
    },
    [updateToken.fulfilled]: (state, action) => {
      const index = state.items.findIndex((user) => user.id === action.payload.id);
      state.items[index] = {
        ...state[index],
        ...action.payload
      };
    },
    [deleteToken.pending]: (state, action) => {
      state.loading_state = LoadingState.loading
    },
    [deleteToken.fulfilled]: (state, action) => {
      const index = state.items.findIndex(({ id }) => id === action.payload.id);
      state.items.splice(index, 1);
      state.loading_state = LoadingState.ready
    },
    [deleteToken.rejected]: (state, action) => {
      return {
        items: state.items,
        loading_state: LoadingState.ready
      }
    },
  }
});

const { reducer } = tokenSlice;
export default reducer;
